// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"4b585a50","647":"633c6a91"}[chunkId] + ".chunk.js";
};